import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import DatePicker from "react-datepicker"
import Loader from "components/Loader"
import moment from "moment"
import {
  useQueryParam,
  StringParam,
  withDefault
} from "use-query-params"
import {
  ADMIN
} from "utils/constants"
import FilterDropdown from "components/FilterDropdown"
import { roleCheck } from "utils/index"
import TimeSpentTable from "./TimeSpentTable"
import { getBaseUrl, getCurrentRole, getCurrentUser } from "../../reducers"
import { getTimeSpentReports } from "../../../../requesters/timeSpentRequester"

const CompletedJobsOverview = () => {
  const baseUrl = useSelector(getBaseUrl)
  const currentRole = useSelector(getCurrentRole)
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const isAdmin = currentRole.includes(ADMIN)

  if (!isAdmin) window.location = "/"

  const getDate = val => {
    const momentObj = moment(val)
    const dateString = momentObj.format("YYYY-MM-DD")
    return dateString
  }

  // Query parameters for filters
  const customDateParam = withDefault(StringParam, getDate(new Date()))
  const [startDate, setStartDate] = useQueryParam("start_date", customDateParam)
  const [endDate, setEndDate] = useQueryParam("end_date", customDateParam)
  const [selectedProductType, setSelectedProductType] = useQueryParam("product_type", StringParam)
  const [selectedCustomFilter, setSelectedCustomFilter] = useQueryParam("filter", StringParam)

  // State variables
  const [requesting, setRequesting] = useState(true)
  const [completedJobsData, setCompletedJobsData] = useState([])
  const [productTypeOptions, setProductTypeOptions] = useState([])

  // Predefined filter options
  const customFilterOptions = [
    ["Underquoted", "underquoted"],
    ["Less than 10 hours Spent", "less_than_10_hours_spent"],
    ["Over Budget by 0% - 10%", "over_budget_less_than_10_percentage"],
    ["Over Budget by 10% - 30%", "over_budget_between_10_30_percentage"],
    ["Over Budget by 30%+", "over_budget_more_than_30_percentage"]
  ]

  const initialFilters = {
    start_date: startDate,
    end_date: endDate,
    product_type: selectedProductType,
    custom_filter: selectedCustomFilter,
  }
  const [filters, setFilters] = useState(initialFilters)

  const fetchData = () => {
    setRequesting(true)
    getTimeSpentReports(baseUrl, filters)
      .then(res => {
        if (res.status === 200 && res.response) {
          const allTypes = res.response.productTypes?.map(type => [type, type]) || []
          setProductTypeOptions(allTypes)
          setCompletedJobsData(res.response.completedJobs || [])
        }
        setRequesting(false)
      })
      .catch(err => {
        console.log(err)
        setRequesting(false)
      })
  }

  useEffect(() => {
    fetchData()
  }, [startDate, endDate, selectedProductType, selectedCustomFilter])

  const onStartDateChange = val => {
    const newStartDate = getDate(val)
    setStartDate(newStartDate)
    setFilters({ ...filters, start_date: newStartDate })
  }

  const onEndDateChange = val => {
    const newEndDate = getDate(val)
    setEndDate(newEndDate)
    setFilters({ ...filters, end_date: newEndDate })
  }

  const setProductType = val => {
    setSelectedProductType(val)
    setFilters({ ...filters, product_type: val })
  }

  const setCustomFilter = val => {
    setSelectedCustomFilter(val)
    setFilters({ ...filters, custom_filter: val })
  }

  const getFilterName = (key, options) => {
    const selectedOption = options.find(o => o[1] === filters[key])
    const filteredName = selectedOption ? selectedOption[0] : ""

    return filteredName
  }

  const clearStates = () => {
    setFilters({})
    setStartDate(undefined)
    setEndDate(undefined)
    setSelectedProductType(undefined)
    setSelectedCustomFilter(undefined)
  }

  useEffect(() => {
    return () => clearStates()
  }, [])

  const startDateObject = moment(startDate, "YYYY-MM-DD").toDate()
  const endDateObject = moment(endDate, "YYYY-MM-DD").toDate()

  return (
    <React.Fragment>
      {/* Filters */}
      <div className="table-listing-filters d-md-flex flex-row justify-content-between mb-4">
        <div className="d-flex flex-row align-items-center">
          <div className="btn-group mr-2">
            <FilterDropdown
              title="Filter"
              filteredName={getFilterName("custom_filter", customFilterOptions)}
              setFilter={setCustomFilter}
              options={customFilterOptions} />
          </div>
          <div className="btn-group mr-2">
            <DatePicker
              selected={startDateObject}
              selectsStart
              startDate={startDateObject}
              endDate={endDateObject}
              dateFormat="dd/MM/yyyy"
              onChange={onStartDateChange}
              placeholderText="From" />
            <DatePicker
              selected={endDateObject}
              selectsEnd
              startDate={startDateObject}
              endDate={endDateObject}
              dateFormat="dd/MM/yyyy"
              onChange={onEndDateChange}
              placeholderText="To" />
          </div>
          <div className="btn-group">
            <FilterDropdown
              title="Products"
              filteredName={selectedProductType}
              setFilter={setProductType}
              options={productTypeOptions} />
          </div>
        </div>
        {/* <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {}}>
            <i className="fas fa-download mr-1"></i>
            Download
          </button>
        </div> */}
      </div>

      {requesting ? (
        <Loader />
      ) : (
        <>
          <TimeSpentTable data={completedJobsData} reloadData={fetchData} />
        </>
      )}
    </React.Fragment>
  )
}

export default CompletedJobsOverview